// App Scope:
// - Serve the openWizard function to show the wizard after click on CTA.
document.addEventListener('alpine:init', () => {
    window.Alpine.data('wizardApp', () => ({
        openWizard: {
            ['@click']() {
                // hide navigation if openWizard was clicked
                this.$store.globalStore.showNavi = false;

                // set global key to true to prevent body scrolling
                this.$store.modalStore.openModal = true;

                // check if wizard form was not submitted yet
                if(this.$store.modalStore.wizardModalStatus) {
                    // open custom Modal
                    this.$store.modalStore.currentModalName = 'wizardModal';
                    if (document.querySelector('form[data-firstfieldautofocus="true"]')) {
                        setTimeout(() => initFocusObserverForForms(), 50);
                    };
                } else {
                    this.$store.modalStore.currentModalName = 'wizardSuccessModal';
                }
            }
        },
    }));
})
